import { all, fork } from 'redux-saga/effects'

import * as types from '../actions/actionTypes'
import { forkWatch } from '../libs/sagaHelpers'

import * as buyerSaga from './buyerSaga'
import * as creatorSaga from './creatorSaga'
import * as inflowHistorySaga from './inflowHistorySaga'
import * as itemEntrySaga from './itemEntrySaga'
import * as landingSaga from './landingSaga'
import * as outflowHistorySaga from './outflowHistorySaga'
import * as sellerHistorySaga from './sellerHistorySaga'
import * as smsSaga from './smsSaga'
import * as tapPaySaga from './tapPaySaga'
import * as userSaga from './userSaga'
import * as withdrawSaga from './withdrawSaga'

export default function* rootSaga() {
  yield all([
    forkWatch(types.LOGIN, userSaga.loginSaga),
    forkWatch(types.REFRESH_TOKEN, userSaga.refreshTokenSaga),
    forkWatch(types.VENDOR_LOGIN, userSaga.vendorLoginSaga),
    forkWatch(types.LOGOUT, userSaga.logoutSaga),
    forkWatch(types.CLEAN_VENDOR_LOGIN, userSaga.cleanVendorLoginSaga),

    forkWatch(types.CREATE_CREAM_ITEM, creatorSaga.createCreamItemSaga),
    forkWatch(types.TERMINATE_CREAM_ITEM, creatorSaga.terminateCreamItemSaga),
    forkWatch(types.GET_SLASH_INFO, creatorSaga.getSlashInfoSaga),
    forkWatch(types.GET_PAYMENT_INFO_GUEST, buyerSaga.getPaymentInfoGuestSaga),
    forkWatch(
      types.GET_PAYMENT_INFO_MEMBER,
      buyerSaga.getPaymentInfoMemberSaga,
    ),

    forkWatch(types.SEND_SMS, smsSaga.sendSMSSaga),
    forkWatch(types.CONFIRM_SMS, smsSaga.confirmSMSSaga),

    forkWatch(types.LOAD_TAPPAY_SDK, tapPaySaga.loadTapPaySDKSaga),
    forkWatch(types.CHECKOUT_TAPPAY, tapPaySaga.checkoutTapPaySaga),
    forkWatch(
      types.CHECKOUT_TAPPAY_INSTALMENT,
      tapPaySaga.checkoutTapPayInstalmentSaga,
    ),
    forkWatch(
      types.CHECKOUT_TAPPAY_PERIODIC,
      tapPaySaga.checkoutTapPayPeriodicSaga,
    ),

    forkWatch(types.CALCULATE_WITHDRAW, withdrawSaga.calculateWithdrawSaga),
    forkWatch(types.MAKE_WITHDRAW, withdrawSaga.makeWithdrawSaga),

    forkWatch(types.GET_ITEM_ENTRY_INFO, itemEntrySaga.getItemEntryInfoSaga),
    forkWatch(
      types.GET_BUYER_INSTALMENTS_INFO,
      itemEntrySaga.getBuyerInstalmentsInfoSaga,
    ),
    forkWatch(
      types.GET_BUYER_PERIODIC_INFO,
      itemEntrySaga.getBuyerPeriodicInfoSaga,
    ),

    forkWatch(
      types.GET_OUTFLOW_HISTORIES,
      outflowHistorySaga.getOutflowHistoriesSaga,
    ),
    forkWatch(
      types.GET_OUTFLOW_PAYMENT_DETAIL,
      outflowHistorySaga.getOutflowPaymentDetailSaga,
    ),
    forkWatch(
      types.GET_OUTFLOW_WITHDRAW_DETAIL,
      outflowHistorySaga.getOutflowWithdrawDetailSaga,
    ),

    forkWatch(
      types.GET_SELLER_HISTORIES,
      sellerHistorySaga.getSellerHistoriesSaga,
    ),
    forkWatch(
      types.GET_SELLER_HISTORY_DETAIL,
      sellerHistorySaga.getSellerHistoryDetailSaga,
    ),
    forkWatch(
      types.GET_INSTALMENT_HISTORIES,
      sellerHistorySaga.getInstalmentHistoriesSaga,
    ),

    forkWatch(
      types.GET_INFLOW_HISTORIES,
      inflowHistorySaga.getInflowHistoriesSaga,
    ),
    forkWatch(
      types.GET_INFLOW_HISTORY_DETAIL,
      inflowHistorySaga.getInflowHistoryDetailSaga,
    ),

    forkWatch(types.START_LANDING_FETCH, landingSaga.fetchLandingSaga),

    fork(userSaga.authFlowSaga),
  ])
}
